export default __webpack_public_path__ + "static/media/MFF_logo.c4c7d78f.png";